import { useState } from "react";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "../../../shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalFooter } from "../../../shared/wrappers/FixaModal/FixaModalFooter";
import { FixaInputField } from "../../../shared/wrappers/FixaInputField/FixaInputField";
import {
  FixaSelect,
  FixaOption,
} from "../../../shared/wrappers/FixaSelect/FixaSelect";
import FixaButton from "../../../shared/wrappers/FixaButton/FixaButton";
import {
  useGetAllPermissions,
  useCreateStorePermission,
} from "../../repositories/permissions.repository";
import { FixaModalBody } from "../../../shared/wrappers/FixaModal/FixaModalBody";
import { BasePermission } from "../../types/BasePermission";

type Props = {
  isVisible: boolean;
  setIsOpen: (open: boolean) => void;
};

const EnableStorePermissionModal = ({ isVisible, setIsOpen }: Props) => {
  const [permissionId, setPermissionId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [value, setValue] = useState(true);

  const { data: permissions = [], isLoading: isLoadingPermissions } =
    useGetAllPermissions();
  const createStorePermissionMutation = useCreateStorePermission();

  const handleAddClick = async () => {
    try {
      await createStorePermissionMutation.mutateAsync({
        permission_id: permissionId,
        store_id: storeId,
        value,
      });
      // Clear form and close modal on success
      setPermissionId("");
      setStoreId("");
      setValue(true);
      setIsOpen(false);
    } catch {
      // Keep modal open on error so user can retry
    }
  };

  const handleClose = () => {
    setPermissionId("");
    setStoreId("");
    setValue(true);
    setIsOpen(false);
  };

  return (
    <FixaModal visible={isVisible} handleCloseBtn={handleClose}>
      <FixaSheets
        labelledById="feature-flags-enable-store-permissions-modal-header"
        alignment="right"
        preserveAlignment={false}
        size="small"
        fullSize
        header={
          <FixaModalHeader
            id="feature-flags-enable-store-permissions-modal-header"
            title={"Enable permission for store"}
            floating={false}
          />
        }
        footer={
          <FixaModalFooter>
            <FixaButton
              onClick={handleAddClick}
              disabled={!permissionId || !storeId}
            >
              Add
            </FixaButton>
          </FixaModalFooter>
        }
      >
        <FixaModalBody>
          <FixaSelect
            id={"permissionIdSelect"}
            value={permissionId}
            onChange={(e) => setPermissionId(e.target.value)}
            label={"Permission code"}
            disabled={isLoadingPermissions}
          >
            <FixaOption value="" name="Select a permission" />
            {permissions.map((permission: BasePermission) => (
              <FixaOption
                key={permission.code}
                value={permission.code}
                name={`${permission.code} - ${permission.description}`}
              />
            ))}
          </FixaSelect>
          <FixaInputField
            id={"storeIdInput"}
            type={"text"}
            value={storeId}
            onChange={(e) => setStoreId(e.target.value)}
            label={"Store ID"}
          />
          <div>
            <label>
              <input
                type="checkbox"
                checked={value}
                onChange={(e) => setValue(e.target.checked)}
              />
              {" Enabled"}
            </label>
          </div>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};

export default EnableStorePermissionModal;
